import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { coach } from '../../config/coach';

const ParallaxBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], ['-12%', '12%']);

  return (
    <section ref={ref} className="relative h-[70vh] sm:h-[85vh] overflow-hidden" data-testid="parallax-band">
      <motion.div className="absolute inset-0 -top-[12%] -bottom-[12%] will-change-transform" style={{ y }}>
        <img
          src={coach.images.band}
          alt={`${coach.fullName} training session`}
          className="w-full h-full object-cover object-[50%_28%] img-grade"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/40 to-black" />

      <div className="relative z-10 h-full mx-auto max-w-7xl px-5 sm:px-8 flex items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="font-display font-bold uppercase text-white leading-[0.95] tracking-tight text-4xl sm:text-6xl lg:text-7xl">
            No shortcuts.<br />
            <span className="text-white/40">Just a plan you'll</span><br />
            actually follow.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ParallaxBand;
